import React from "react";
import { useResourcesState } from "@/state/resourcesState";
import { round } from "@/3d/math";

export const EditorStatusBar = () => {
    const { loadingProgress } = useResourcesState();

    return (
        <div className="d-flex gap-2 p-1 align-items-center">
            <span>Загрузка: {round(loadingProgress * 100, 1)}%</span>
        </div>
    );
};
